import { css } from "@emotion/react";

import { dimensions } from "@styles";

export const stepper = css`
  @media (min-width: ${dimensions.desktop}) {
    padding-left: 10rem;
    padding-right: 10rem;
  }
`;
